export const FETCH_MODELS = "FETCH_MODELS";
export const SET_MODELS_DATA = "SET_MODELS_DATA";
export const SET_MODELS = "SET_MODELS";
